import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { reviewAndPlaceOrderStyles } from "@dana/Overrides/Widgets/OnePageCheckout/OnePageCheckoutReviewAndPlaceOrder";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

reviewAndPlaceOrderStyles.container = mergeToNew(
    reviewAndPlaceOrderStyles.container,
    {
        gap: 0,
        css: css`
            background: ${themeBackgrounds.white};
        `,
    },
);

reviewAndPlaceOrderStyles.titleGridItem = mergeToNew(
    reviewAndPlaceOrderStyles.titleGridItem,
    {
        width: 12,
        css: css`
            background: ${themeBackgrounds.lightGray};
            padding: 16px;
        `,
    },
);

reviewAndPlaceOrderStyles.titleText = mergeToNew(
    reviewAndPlaceOrderStyles.titleText,
    {
        transform: "capitalize",
        size: fontSizes.medium,
        lineHeight: lineHeights.medium,
        css: css`
            margin-bottom: 0;
            letter-spacing: normal;
        `,
    },
);

reviewAndPlaceOrderStyles.cartTotalGridItem = mergeToNew(
    reviewAndPlaceOrderStyles.cartTotalGridItem,
    {
        css: css`
            padding: 16px;
        `,
    },
);

reviewAndPlaceOrderStyles.checkboxesGridItem = mergeToNew(
    reviewAndPlaceOrderStyles.checkboxesGridItem,
    {
        css: css`
            padding: 16px;
            padding-top: 0;
        `,
    },
);

reviewAndPlaceOrderStyles.placeOrderGridItem = mergeToNew(
    reviewAndPlaceOrderStyles.placeOrderGridItem,
    {
        css: css`
            padding: 16px;
            gap: 8px
        `,
    },
);

reviewAndPlaceOrderStyles.placeOrderButton = mergeToNew(
    reviewAndPlaceOrderStyles.placeOrderButton,
    {
        css: css`
            width: 100%;
        `,
    },
);

reviewAndPlaceOrderStyles.submitForApprovalButton = mergeToNew(
    reviewAndPlaceOrderStyles.submitForApprovalButton,
    {
        css: css`
            width: 100%;
        `,
    },
);

reviewAndPlaceOrderStyles.downloadButton = mergeToNew(
    reviewAndPlaceOrderStyles.downloadButton,
    {
        variant: "secondary",
        css: css`
            width: 100%;
        `,
    },
);

reviewAndPlaceOrderStyles.actionButton = mergeToNew(
    reviewAndPlaceOrderStyles.actionButton,
    {
        css: css`
            width: 100%;
        `,
    },
);

reviewAndPlaceOrderStyles.placeOrderErrorMessageGridItem = mergeToNew(
    reviewAndPlaceOrderStyles.placeOrderErrorMessageGridItem,
    {
        css: css`
            padding: 16px;
        `,
    },
);

reviewAndPlaceOrderStyles.cartTotal = mergeToNew(reviewAndPlaceOrderStyles.cartTotal, {
    subtotalLabel: {
        weight: fontWeights.regular,
    },
    promotionLabel: {
        weight: fontWeights.regular,
    },
    discountsLabel: {
        weight: fontWeights.regular,
    },
    shippingAndHandlingLabel: {
        weight: fontWeights.regular,
    },
    otherChargesLabel: {
        weight: fontWeights.regular,
    },
    taxLabel: {
        weight: fontWeights.regular,
    },
    totalLabel: {
        weight: fontWeights.regular,
    },
    subtotalValue: {
        weight: fontWeights.semiBold,
    },
    promotionValue: {
        weight: fontWeights.semiBold,
    },
    discountsValue: {
        weight: fontWeights.semiBold,
    },
    shippingAndHandlingValue: {
        weight: fontWeights.semiBold,
    },
    otherChargesValue: {
        weight: fontWeights.semiBold,
    },
    taxValue: {
        weight: fontWeights.semiBold,
    },
    totalValue: {
        weight: fontWeights.semiBold,
    },
});
